import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { rankingsService } from '../services/rankings.service'

export const RANKING_ETAPA_KEY = 'ranking-etapa'
export const RANKING_GERAL_KEY = 'ranking-geral'

export function useRankingEtapa(params: {
  idcampeonato: number | null
  idmodalidade: number | null
  idetapa: number | null
}) {
  const enabled = params.idcampeonato !== null && params.idmodalidade !== null && params.idetapa !== null
  return useQuery({
    queryKey: [RANKING_ETAPA_KEY, params],
    queryFn: () =>
      rankingsService.getEtapa({
        idcampeonato: params.idcampeonato!,
        idmodalidade: params.idmodalidade!,
        idetapa: params.idetapa!,
      }),
    enabled,
    staleTime: 0,
  })
}

export function useRankingGeral(params: {
  idcampeonato: number | null
  idmodalidade: number | null
}) {
  const enabled = params.idcampeonato !== null && params.idmodalidade !== null
  return useQuery({
    queryKey: [RANKING_GERAL_KEY, params],
    queryFn: () =>
      rankingsService.getGeral({
        idcampeonato: params.idcampeonato!,
        idmodalidade: params.idmodalidade!,
      }),
    enabled,
    staleTime: 0,
  })
}

export function useRecalcularRanking() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (params: { idcampeonato: number; idmodalidade?: number }) =>
      rankingsService.recalcular(params),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [RANKING_ETAPA_KEY] })
      qc.invalidateQueries({ queryKey: [RANKING_GERAL_KEY] })
    },
  })
}
